/**
 * 外販時に触るのはこのファイルだけ。
 * 掲載義務のある事業者情報と、同意文言に出る提携社数をここで一元管理します。
 */
export const CONFIG = {
  company: "one more",
  address: "愛知県名古屋市港区曽池町3-52",
  /** 規約類は /driver/agreements の1ページにまとめ、見出しごとにアンカーで飛ばします */
  termsUrl: "/driver/agreements#terms",
  privacyUrl: "/driver/agreements#privacy",
  /** 第三者提供の同意に必要。提供先を特定できる状態にするための一覧ページ */
  partnersUrl: "/driver/agreements#partners",
  /**
   * 特定募集情報等提供事業者の届出受理番号（サイト上への表示義務あり）。
   * 空文字のあいだは表示欄ごと出しません。届出が受理され次第ここに入れてください。
   */
  noticeNo: "",
  /** 問い合わせ窓口。提供停止の申し出もここで受けます */
  contactEmail: "info@onemore.asia",
  /** 1リードあたりの同時配信社数の上限（同意文言にも出ます） */
  maxPartners: 4,
  /**
   * リード送信先。既定は Hosting の rewrite 経由で Cloud Functions を叩きます
   * （同一オリジンなので CORS 不要）。ローカル開発でエミュレータを直接叩く場合は
   * .env.local に VITE_LEAD_ENDPOINT を設定してください。
   */
  endpoint: import.meta.env.VITE_LEAD_ENDPOINT ?? "/api/lead",
  /** 完了後に飛ばしたいURLがあれば指定（null なら完了画面を表示） */
  thanksUrl: null as string | null,
  areaPlaceholder: "愛知県〇〇市周辺",
} as const;

/**
 * 免許：制度上AT限定が存在する区分だけ at:true。
 *  ・普通免許 → AT限定あり
 *  ・準中型5t限定（旧・普通／2007-2017取得）→ AT限定あり
 *  ・中型8t限定（旧・普通／2007年以前取得）→ AT限定あり
 *  ・準中型／中型／大型（現行区分）→ AT限定という設定が存在しない
 */
export const LICENSES: ReadonlyArray<{ v: string; at: boolean }> = [
  { v: "普通免許", at: true },
  { v: "準中型免許（5t限定）", at: true },
  { v: "準中型免許", at: false },
  { v: "中型免許（8t限定）", at: true },
  { v: "中型免許", at: false },
  { v: "大型免許", at: false },
];
